var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.33325 13.9999C2.33325 20.4432 7.5566 25.6666 13.9999 25.6666C20.4432 25.6666 25.6666 20.4432 25.6666 13.9999C25.6666 7.5566 20.4432 2.33325 13.9999 2.33325C7.5566 2.33325 2.33325 7.5566 2.33325 13.9999ZM23.5454 13.9999C23.5454 19.2717 19.2717 23.5454 13.9999 23.5454C8.72811 23.5454 4.45446 19.2717 4.45446 13.9999C4.45446 8.72811 8.72811 4.45446 13.9999 4.45446C19.2717 4.45446 23.5454 8.72811 23.5454 13.9999Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.2499 15.4375L18.425 9.26248L20.0749 10.9124L12.2499 18.7374L7.92496 14.4124L9.57488 12.7625L12.2499 15.4375Z","key":1})]);
}

Check.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Check;

Check.default = Check;
